import {
  HelpCenterActionTypes,
  HelpCenterState,
  SET_HELP_CENTER_STATE,
} from "./types";

export function setHelpCenterState(
  state: HelpCenterState
): HelpCenterActionTypes {
  return { type: SET_HELP_CENTER_STATE, state: state };
}
